class MouseTracker {
  constructor() {
    this.position = { x: 0, y: 0 };
    this.normalized = { x: 0, y: 0 }; // -1 to 1
    this.velocity = { x: 0, y: 0 };
    this.prevPosition = { x: 0, y: 0 };

    this.bind();
  }

  bind() {
    window.addEventListener('mousemove', (e) => {
      // Store previous position for velocity calculation
      this.prevPosition.x = this.position.x;
      this.prevPosition.y = this.position.y;

      // Update position
      this.position.x = e.clientX;
      this.position.y = e.clientY;

      // Calculate normalized coordinates (-1 to 1)
      this.normalized.x = (e.clientX / window.innerWidth) * 2 - 1;
      this.normalized.y = -(e.clientY / window.innerHeight) * 2 + 1;

      // Calculate velocity
      this.velocity.x = this.position.x - this.prevPosition.x;
      this.velocity.y = this.position.y - this.prevPosition.y;
    });

    // Initialize to center of screen
    this.position.x = window.innerWidth / 2;
    this.position.y = window.innerHeight / 2;
  }
}

export default MouseTracker;
